"use strict";
import { jsx, jsxs } from 'react/jsx-runtime';
import { Skeleton, HStack, IconButton, Button, Text } from '@chakra-ui/react';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';

const Pagination = ({ currentPage, itemsPerPage, totalHits, onPageChange, isLoading, colorScheme }) => {
  const numberOfPages = Math.ceil(totalHits / itemsPerPage);
  const buttonsToRender = [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2].filter(
    (page) => page >= 1 && page <= numberOfPages
  );
  return /* @__PURE__ */ jsx(Skeleton, { isLoaded: !isLoading, children: /* @__PURE__ */ jsxs(HStack, { children: [
    /* @__PURE__ */ jsx(
      IconButton,
      {
        size: "sm",
        "aria-label": "first page",
        colorScheme: "gray",
        isDisabled: currentPage === 1,
        onClick: () => onPageChange(currentPage - 1),
        icon: /* @__PURE__ */ jsx(BiChevronLeft, {})
      }
    ),
    currentPage > 3 && /* @__PURE__ */ jsx(Button, { size: "sm", onClick: () => onPageChange(1), colorScheme: currentPage === 1 ? colorScheme : "gray", children: 1 }),
    currentPage > 4 && /* @__PURE__ */ jsx(Text, { children: "..." }),
    buttonsToRender.map((item) => /* @__PURE__ */ jsx(
      Button,
      {
        size: "sm",
        onClick: () => onPageChange(item),
        colorScheme: item === currentPage ? colorScheme : "gray",
        children: item
      },
      item.toString()
    )),
    currentPage < numberOfPages - 3 && /* @__PURE__ */ jsx(Text, { children: "..." }),
    currentPage < numberOfPages - 2 && /* @__PURE__ */ jsx(
      Button,
      {
        size: "sm",
        onClick: () => onPageChange(numberOfPages),
        colorScheme: currentPage === numberOfPages ? colorScheme : "gray",
        children: numberOfPages
      }
    ),
    /* @__PURE__ */ jsx(
      IconButton,
      {
        size: "sm",
        "aria-label": "next page",
        colorScheme: "gray",
        isDisabled: currentPage === numberOfPages || !numberOfPages,
        onClick: () => onPageChange(currentPage + 1),
        icon: /* @__PURE__ */ jsx(BiChevronRight, {})
      }
    )
  ] }) });
};

export { Pagination as default };
